import { ArrowRight } from "lucide-react";
import { DragEvent, useState } from "react";

import { GreenPlaceholder, Policy } from ".";

function StepDropZone({
  onDrop,
  onClickAddStep,
  stepNumber,
  isLastDropZone,
  allPoliciesUsed,
  hoverAddIndex,
  setHoverAddIndex,
  height,
}: {
  onDrop: (policy: Policy) => void;
  onClickAddStep: () => void;
  stepNumber: number;
  isLastDropZone: boolean;
  allPoliciesUsed: boolean;
  hoverAddIndex: number | null;
  setHoverAddIndex: (idx: number | null) => void;
  height: number | undefined;
}) {

  const [isOver, setIsOver] = useState(false);

  const handleDragEnter = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (isLastDropZone && !allPoliciesUsed) {
      setHoverAddIndex(stepNumber);
    }
  };

  const handleDragOver = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.dropEffect = "copy";
  };

  const handleDragLeave = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setHoverAddIndex(null);
  };

  const handleDrop = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setHoverAddIndex(null);

    try {
      const jsonData = e.dataTransfer.getData("application/json");
      if (jsonData) {
        const data = JSON.parse(jsonData);
        if (data.type === "POLICY") {
          onDrop(data.policy);
        }
      }
    } catch (err) {
      console.error("Drop error:", err);
    }
  };

  const handleButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    onClickAddStep();
  };

  // If it's the last drop zone and all policies are used, don't show anything
  if (isLastDropZone && allPoliciesUsed) {
    return null;
  }

  // If not the last drop zone, just show connector line
  if (!isLastDropZone) {
    return (
      <div className="sequence-drop-zone">
        <div className="sequence-connector-line" />
      </div>
    );
  }

  // Last drop zone shows the "Add Step" button (only if policies remain)
  return (
    <div
      onDragEnter={handleDragEnter}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      className={`sequence-drop-zone ${isOver ? "drag-over" : ""}`}
      style={{ height: height || "auto" }}
    >
      <div className="sequence-connector-line" />
      {hoverAddIndex === stepNumber ? (
        <GreenPlaceholder label={`Add Stage ${stepNumber} here`} height={285} />
      ) : (
        <button
          className="sequence-add-step-btn"
          onClick={handleButtonClick}
        >
          <ArrowRight /> Add Stage {stepNumber} here
        </button>
      )}

    </div>
  );
}
export default StepDropZone;
